<template>
  <div>
    <Borrowed :change_resident_id="change_resident_id" />
    <Lent @handleToResident="handleToResident" />
  </div>
</template>

<script>
import Borrowed from "./Borrowed";

import Lent from "./Lent";

export default {
  name: "Devolution",

  components: {
    Borrowed,
    Lent,
  },

  data() {
    return {
      change_resident_id: "",
    };
  },

  methods: {
    handleToResident(resident_id) {
      this.change_resident_id = resident_id;
      this.$emit("handleToResident", resident_id);
    },
  },
};
</script>
